import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const DOMControllerOutlined: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M17 1H3C1.9 1 1 1.9 1 3V17C1 18.1 1.9 19 3 19L9 19V22C9 22.5523 9.44772 23 10 23H22C22.5523 23 23 22.5523 23 22V2C23 1.44772 22.5523 1 22 1C21.4477 1 21 1.44772 21 2V21H11V19L17 19C18.1 19 19 18.1 19 17V3C19 1.9 18.1 1 17 1ZM17 17H3V3H17V17Z"
      fill="currentColor"
    />
    <path d="M11 10.5V9H9.5V10.5H11Z" fill="currentColor" />
    <path
      d="M9 16H11.5C12.05 16 12.5 15.55 12.5 15V12.5C12.5 11.95 12.05 11.5 11.5 11.5H9C8.45 11.5 8 11.95 8 12.5V15C8 15.55 8.45 16 9 16ZM9.5 13H11V14.5H9.5V13Z"
      fill="currentColor"
    />
    <path d="M11 8V6.5H9.5V8H11Z" fill="currentColor" />
    <path d="M11 5.5V4H9.5V5.5H11Z" fill="currentColor" />
  </SvgIcon>
);

export default DOMControllerOutlined;
